module.exports = __webpack_public_path__ + "static/media/plane_s.63bb8dbb.jpg";